import { formatAge } from "../../engine/text";
import type { LogEntry } from "../../engine/types";

export function Timeline({ log, newestFirst = false }: { log: readonly LogEntry[]; newestFirst?: boolean }) {
  const entries = newestFirst ? [...log].reverse() : log;
  return (
    <ol className="timeline">
      {entries.map((e, i) => (
        <li key={newestFirst ? log.length - i : i}>
          <span className="age">{formatAge(e.ageDays)}</span>
          <span>{e.text}</span>
        </li>
      ))}
    </ol>
  );
}
